module.exports = __webpack_public_path__ + "static/images/monet/left_menu_background.gif";